// extracted by mini-css-extract-plugin
module.exports = {"figure":"AvatarInitials_figure__3kRf2","span":"AvatarInitials_span__1E7CT"};